
<template>
  <footer>
    <common-go-to-top v-if="isMobile" />
    <div class="l-footer js-footer">
      <div class="l-footer__links">
        <ul class="l-footer__list">
          <li class="l-footer__item">
            <a class="c-link" target="_blank" href="/terms/">利用規約</a>
          </li>
          <li class="l-footer__item">
            <a class="c-link" target="_blank" href="https://ki-group.co.jp/policy/">プライバシーポリシー</a>
          </li>
          <li class="l-footer__item">
            <a class="c-link" target="_blank" href="/contact/">お問い合わせ</a>
          </li>
        </ul>
      </div>
      <div class="l-footer__bottoms">
        <img
          class="l-footer__logo"
          src="@/assets/icon_s.png"
          alt="ALT"
        />
        <small class="l-footer__copyright">Copyright &copy; ケイアイスター不動産 All Rights Reserved.</small>
      </div>
    </div>

  </footer>
</template>


<script>
import CommonGoToTop from '@/components/parts/CommonGoToTop';
import IsMobile from '@/plugins/isMobile';


export default {
  name: 'CommonFooter',
  mixins: [IsMobile],
  components: {
    CommonGoToTop,
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang='scss'>
@charset "UTF-8";

.l-footer {
  width: 100%;
  padding: 20px 40px;
  border-top: 1px solid #ccc;
  background-color:#FFF;

  &__links {
    margin-bottom: 24px;
  }
  &__list {
    display: flex;
    align-items: center;
  }
  &__item {
    &:after {
      content: "|";
      padding: 0 10px;
    }
    &:last-child {
      &:after {
        content: none;
      }
    }
  }
  &__link {
    color: #666;
    font-size: 12px;
  }
  &__bottoms {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__logo {
    width: 67px;
    height: 31px;
    margin-right: 20px;
  }
  &__copyright {
    color: #666;
    font-size: 12px;
  }
}

.c-link {
  font-size:12px;
}


@media screen and (max-width: 767px) {
  .l-footer {
    padding: 20px 15px;
    &__links {
      margin-bottom: 20px;
    }
    &__list {
      justify-content: center;
    }
    &__bottoms {
      justify-content: center;
    }
    &__logo {
      margin-bottom: 20px;
    }
    &__copyright {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
